import { render } from "./ExecutiveDashboard.vue?vue&type=template&id=ad219e66&scoped=true"
import script from "./ExecutiveDashboard.vue?vue&type=script&lang=js"
export * from "./ExecutiveDashboard.vue?vue&type=script&lang=js"

import "./ExecutiveDashboard.vue?vue&type=style&index=0&id=ad219e66&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad219e66"]])

export default __exports__